// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-card[data-v-bd1ca32c]{width:auto;max-width:60%}.modal-card-body[data-v-bd1ca32c]{color:#4a4a4a;min-height:5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
